import logger from "@FRAMEWORK/utils/logger";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {useQuery, UseQueryOptions} from "@tanstack/react-query";

type GlobalMenu = {
	align: string; // 중앙정렬 여부
	allOpenYn: string;
	areaMainYn: string;
	classNm: string;
	commCdNm: string;
	dspGrpCd: string;
	dspMenu: string;
	dspNm: string;
	dspOrder: number;
	dspSid: string;
	dspSidHi: string;
	dspSidLoc: string;
	dspTypeCd: string;
	dspUrl: string;
	gnbTypeCd: string;
	homeYn: string;
	iconType: string;
	iconYn: string;
	keywordYn: string;
	locTypeCd: string;
	lv: number;
	mdspUrl: string;
	menuTypeCd: string;
	mnewWindowYn: string;
	mobileYn: string;
	newWindowYn: string;
	singleTypeCd: string;
	subDspNm: string;
	subDspOrder: number;
	subDspTypeCd: string;
	subDspUrl: string;
	tempRervCntYn: string;
	themaYn: string;
	useYn: string;
	webMenuPftype: string;
	webMenuTarget: "SELF" | "NEW" | "IFRAME";
	mwebMenuTarget: "SELF" | "NEW" | "IFRAME";
	talkMsg: string;
	talkUrl: string;
	talkYn: "Y" | "N";
	pageId: string /* seo 용도로 사용 */;
};

type GlobalMenuBff = {
	menuLv1List: GlobalMenu[];
	menuLv2List: GlobalMenu[];
	menuLv3List: GlobalMenu[];
	menuLv4List?: GlobalMenu[];
	proMenuList: GlobalMenu[];
	subMenuList: GlobalMenu[];
};

type GlobalMenuParams = {
	dspTypeCd?: string;
	dspSid?: string;
	level?: string;
};

const key = "useGlobalMenuBFF";
const getPath = (): string | null => `${process.env.ENV_SUPPORT_URL}/api/bff/menu/list`;

const menuSSR = async (params: {
	dspSid?: string;
	dspTypeCd?: string;
	level?: string;
}): Promise<{data: Response<GlobalMenuBff>}> => useConfigureAxios(getPath(), {params});
/**
 * @description 공통메뉴정보 BFF
 */
const useGlobalMenu = (params?: GlobalMenuParams, options?: Partial<UseQueryOptions<{body: GlobalMenuBff}>>) => {
	try {
		return useQuery({
			queryKey: [key, JSON.stringify(params)],
			queryFn: () => useConfigureAxios({url: getPath(), params}).then(r => r.data),
			staleTime: Infinity,
			gcTime: Infinity,
			throwOnError: false,
			placeholderData: {
				body: {
					menuLv1List: [],
					menuLv2List: [],
					menuLv3List: [],
					menuLv4List: [],
					pmoMenuList: [],
					subMenuList: [],
				},
			},
			...options,
		});
	} catch (error) {
		logger.error(error);
	}
};

export default useGlobalMenu;
export {menuSSR};
export type {GlobalMenu, GlobalMenuBff};
